import moment from 'moment';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../../App';
import DatePicker from '../../../../../Components/DatePicker/DatePicker';
import Dropdown from '../../../../../Components/Dropdown/Dropdown';
import { Button } from '../../../../../Components/StyledComponents';
import './TempStop.scss';

/* ***
Wating TempStop 참고
*** */

let hourOptions = []
let minuteOptions = []

const TempStop = ({ tempDayOffs, patchTempStop}) => {
    const [ reason, setReason ] = React.useState('가게사정')
    const [ startHour, setStartHour ] = React.useState(moment(new Date()).format('HH'));
    const [ startMin, setStartMin ] = React.useState(0);
    const [ closeHour, setCloseHour ] = React.useState(moment(new Date()).format('HH'));
    const [ closeMin, setCloseMin ] = React.useState(0);
    const [ tempHolidays, setTempHolidays ] = React.useState([]);
    const [ endHourOptions, setEndHourOptions ] = React.useState([])

    React.useEffect(() => {
        let nowHour = moment(new Date()).format('HH')
        for(let i=0;i<=23;i++){
            if( i >= nowHour ) hourOptions.push({ key : i + '시', value : i})
            if( i < 6 ) minuteOptions.push({ key : i * 10 + '분', value : i * 10 })
        }

        if(typeof tempDayOffs !== 'undefined' ){
            for(let i=0; i < tempDayOffs.length; i++){
                setTempHolidays(old => 
                    [...old,
                        { StartDate : new Date(tempDayOffs[i].StartYear + '-' + tempDayOffs[i].StartMonth + '-' + tempDayOffs[i].StartDay), 
                        EndDate : new Date(tempDayOffs[i].EndYear + '-' + tempDayOffs[i].EndMonth + '-' + tempDayOffs[i].EndDay)
                    }])
            }
        }
    },[])

    useEffect(() => {
        let arr = []
        if(closeHour < startHour) setCloseHour(startHour)
        else setCloseHour(old => old)
        for(let i=startHour;i<=23;i++){
            arr.push({ key : i + '시', value : i})
        }
        setEndHourOptions(arr)
    },[startHour])

    const handleTempStart = (val,i) => {
        let arr = tempHolidays;

        arr[i].StartDate = val;

        setTempHolidays([...arr])
    }

    const handleTempEnd = (val,i) => {
        let arr = tempHolidays;

        arr[i].EndDate = val;

        setTempHolidays([...arr])
    }

    const removeTempHolidays = (i) => {
        let arr = tempHolidays;

        arr.splice(i,1)

        setTempHolidays([...arr])
    }

    const addTempHolidays = () => {
        if( tempHolidays.length > 0 && tempHolidays[tempHolidays.length - 1].StartDate === '' && tempHolidays[tempHolidays.length - 1].EndDate === '' ){
            alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
            return;
        }

        setTempHolidays([...tempHolidays,{ StartDate : '', EndDate : ''}])
    }

    const patch = () => {
        patchTempStop({
            Reason : reason,
            StartHour : parseInt(startHour),
            StartMin : parseInt(startMin),
            EndHour : parseInt(closeHour),
            EndMin : parseInt(closeMin)
        })
    }

    return (
        <div className='temp-holiday'>
            <p className='modal-title'>임시 영업중단</p>
            <div className='row'>
                <p className='label'>중단 사유</p>
                <Dropdown
                    options={[
                        { key : '가게사정', value : '가게사정'},
                        { key : '조기종료', value : '조기종료'},
                        { key : '오픈지연', value : '오픈지연'},
                        { key : '연락불가', value : '연락불가'},
                        { key : '해지요청', value : '해지요청'},
                    ]}
                    value={reason}
                    onItemClick={(val) => setReason(val)}
                    width={347}
                />
            </div>

            <div className='row' style={{ marginTop : 16, marginBottom : 16 }}>
                <p className='label'>시작</p>
                <Dropdown
                    options={hourOptions}
                    width={166}
                    onItemClick={val => setStartHour(val)}
                    value={startHour}
                    btnStyle={{ marginRight : 16 }}
                    prefix={'시'}
                    id="starthour"
                />
                <Dropdown
                    options={minuteOptions}
                    width={166}
                    onItemClick={val => setStartMin(val)}
                    value={startMin}
                    prefix={'분'}
                    id="startmin"
                />
            </div>

            <div className='row' style={{ marginTop : 16, marginBottom : 16 }} key={endHourOptions}>
                <p className='label'>종료</p>
                <Dropdown
                    options={endHourOptions}
                    width={166}
                    onItemClick={val => setCloseHour(val)}
                    value={closeHour}
                    btnStyle={{ marginRight : 16 }}
                    prefix={'시'}
                    id="closehour"
                    key={endHourOptions}
                />
                <Dropdown
                    options={minuteOptions}
                    width={166}
                    onItemClick={val => setCloseMin(val)}
                    value={closeMin}
                    prefix={'분'}
                    id="closemin"
                />
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => patch()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default TempStop;